module.exports = __webpack_public_path__ + "static/img/stamp_04.48ca7f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_04.jpg
// module id = WeAW
// module chunks = 7